import { getRailsUpdate } from "@/common/utils/getRailsUpdate";
import { mapToDeletion } from "@/common/utils/railsHelpers";
import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters";
import {
  GovernmentAllocationProductCategoryDistributionValidationSchema,
  GovernmentAllocationProductCategoryDistributionQuantityValidationSchema,
} from "@/features/privateCompanies/schemas/createGovernmentAllocationDistribution.schema";
import { CompanyGovernmentAllocationProductCategoriesDistribution } from "@/features/privateCompanies/types/companyGovernmentAllocation.type";
import {
  transformNewProductDistribution,
  transformUpdatedProductDistribution,
  transformNewProductDistributionQuantity,
  transformUpdatedProductDistributionQuantity,
} from "./transformNewProductDistribution";

export const transformNewProductCategoryDistribution = (
  formProductCategory: GovernmentAllocationProductCategoryDistributionValidationSchema,
  productCategoriesDistributions: CompanyGovernmentAllocationProductCategoriesDistribution[]
) => {
  const productCategoryDistribution = productCategoriesDistributions.find(({ product_category }) => product_category.id === formProductCategory.product_category.id);

  return {
    product_category_id: formProductCategory.product_category.id,
    total_value: formProductCategory.total_value ? unFormatCurrency(formProductCategory.total_value) : 0,
    products_distributions_attributes: [
      ...getRailsUpdate(
        productCategoryDistribution?.products_distributions || [],
        formProductCategory.products_distributions,
        (x) => x.product.id,
        (x) => x.product.id,
        mapToDeletion,
        (productDistribution) => productDistribution.id ? transformUpdatedProductDistribution(productDistribution) : transformNewProductDistribution(productDistribution),
      ),
      ...formProductCategory.products_distributions
        ?.filter((productDistribution) => !!productDistribution.id)
        ?.map((updatedProductDistribution) => transformUpdatedProductDistribution(updatedProductDistribution)) || []
    ],
  };
};

export const transformUpdatedProductCategoryDistribution = (
  formProductCategory: GovernmentAllocationProductCategoryDistributionValidationSchema,
  productCategoriesDistributions: CompanyGovernmentAllocationProductCategoriesDistribution[]
) => {
  const { product_category_id, ...transformedProductCategoryDistribution } = transformNewProductCategoryDistribution(formProductCategory, productCategoriesDistributions);

  return {
    id: formProductCategory.id,
    ...transformedProductCategoryDistribution,
  };
};

export const transformNewProductCategoryDistributionQuantity = (
  formProductCategory: GovernmentAllocationProductCategoryDistributionQuantityValidationSchema,
  productCategoriesDistributions: CompanyGovernmentAllocationProductCategoriesDistribution[]
) => {
  const productCategoryDistribution = productCategoriesDistributions.find(({ product_category }) => product_category.id === formProductCategory.product_category.id);

  return {
    product_category_id: formProductCategory.product_category.id,
    total_quantity: formProductCategory.total_quantity
      ? unFormatUnknownUnit(formProductCategory.total_quantity) >= 0
        ? unFormatUnknownUnit(formProductCategory.total_quantity)
        : undefined
      : 0,
    products_distributions_attributes: [
      ...getRailsUpdate(
        productCategoryDistribution?.products_distributions || [],
        formProductCategory.products_distributions,
        (x) => x.product.id,
        (x) => x.product.id,
        mapToDeletion,
        (productDistribution) => productDistribution.id ? transformUpdatedProductDistributionQuantity(productDistribution) : transformNewProductDistributionQuantity(productDistribution),
      ),
      ...formProductCategory.products_distributions
        ?.filter((productDistribution) => !!productDistribution.id)
        ?.map((updatedProductDistribution) => transformUpdatedProductDistributionQuantity(updatedProductDistribution)) || []
    ],
  };
};

export const transformUpdatedProductCategoryDistributionQuantity = (
  formProductCategory: GovernmentAllocationProductCategoryDistributionQuantityValidationSchema,
  productCategoriesDistributions: CompanyGovernmentAllocationProductCategoriesDistribution[]
) => {
  const { product_category_id, ...transformedProductCategoryDistribution } = transformNewProductCategoryDistributionQuantity(formProductCategory, productCategoriesDistributions);

  return {
    id: formProductCategory.id,
    ...transformedProductCategoryDistribution,
  };
};
